import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { DictionaryOutputs } from '../../../services/dictionary/IDictionaryService';
import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import { getCategoryNextAction } from '../../../store/selectors/category';
import { getDictionaryById } from '../../../store/selectors/dictionary';
import dictionary, {
  DictionaryCloseReason,
} from '../../../store/slices/dictionary';

import DictionaryDialog from './DictionaryDialog';

interface Props {
  id: UniqueId;
  open: boolean;
  catchReturn?: (outputs: DictionaryOutputs) => void;
}

const mapStateToProps = (state: AppState, ownProps: Props) => {
  const { title, outputs, effect } = getDictionaryById(state, ownProps.id);

  return {
    categoryId: ownProps.id,
    title,
    outputsReady: outputs !== null,
    nextAction: getCategoryNextAction(state, ownProps.id),
    effect: effect.type,
  };
};

const mapDispatchToProps = {
  onConfirm: dictionary.submit,
  onCancel: dictionary.close,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  { onConfirm, onCancel }: typeof mapDispatchToProps,
  { id, catchReturn, ...oP }: Props
) => ({
  ...sP,
  ...oP,
  onConfirm: () => onConfirm({ id, value: catchReturn }),
  onCancel: () => onCancel({ id, reason: DictionaryCloseReason.CANCEL }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type DictionaryDialogContainerProps = ConnectedProps<typeof connector>;

export default connector(DictionaryDialog);
